import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import Heading from '../Heading';
import Toolbar from '../Toolbar';
import StackView from '../StackView';

function Section(_ref) {
  var _ref$actions = _ref.actions,
      actions = _ref$actions === void 0 ? [] : _ref$actions,
      children = _ref.children,
      count = _ref.count,
      countColor = _ref.countColor,
      helpContent = _ref.helpContent,
      onStatusClearRequest = _ref.onStatusClearRequest,
      status = _ref.status,
      title = _ref.title,
      restProps = _objectWithoutPropertiesLoose(_ref, ["actions", "children", "count", "countColor", "helpContent", "onStatusClearRequest", "status", "title"]);

  return /*#__PURE__*/React.createElement(StackView, _extends({
    as: "section"
  }, restProps), /*#__PURE__*/React.createElement(Toolbar, {
    title: /*#__PURE__*/React.createElement(Heading, {
      level: 3
    }, title),
    helpContent: helpContent,
    actions: actions,
    count: count,
    countColor: countColor,
    status: status,
    onStatusClearRequest: onStatusClearRequest,
    marginBottom: 2
  }), children);
}

export default Section;